import React, { useState } from 'react';
import { Printer, FileSpreadsheet, FileText } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import axios from 'axios';
import { INV_API } from '../../lib/invApi';

const cls = 'border-[#262626] text-white hover:bg-[#262626]';

// Print / CSV / XLSX of ALL rows matching the current Master Inventory filters (server-built).
export const InventoryExportButtons = ({ params }) => {
  const [busy, setBusy] = useState('');
  const run = async (format) => {
    const win = format === 'print' ? window.open('', '_blank') : null;
    setBusy(format);
    try {
      const { data, headers } = await axios.get(`${INV_API}/items/export`, { withCredentials: true, params: { ...params, format }, responseType: 'blob' });
      const url = URL.createObjectURL(data);
      if (win) { win.location.href = url; } else {
        const name = (headers['content-disposition'] || '').match(/filename="([^"]+)"/)?.[1] || `master-inventory.${format}`;
        const a = document.createElement('a'); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 5000);
      }
    } catch (e) { if (win) win.close(); toast.error('Export failed'); }
    setBusy('');
  };
  return (
    <>
      <Button data-testid="inv-print-btn" disabled={!!busy} onClick={() => run('print')} variant="outline" className={cls}><Printer className="w-4 h-4 mr-2" /> Print</Button>
      <Button data-testid="inv-export-csv-btn" disabled={!!busy} onClick={() => run('csv')} variant="outline" className={cls}><FileText className="w-4 h-4 mr-2" /> CSV</Button>
      <Button data-testid="inv-export-xlsx-btn" disabled={!!busy} onClick={() => run('xlsx')} variant="outline" className={cls}><FileSpreadsheet className="w-4 h-4 mr-2" /> Excel</Button>
    </>
  );
};

export default InventoryExportButtons;
